export default __webpack_public_path__ + "static/l1-hero-img-1-c80884ceeba6349540c21fe03a5a3b87.png";